import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import { connect } from "react-redux";

import { addAppliance, clear, updateAppliance } from "../redux/actions";

const EnergyForm = ({ addAppliance, editAppliance, editApplianceId, clear, updateAppliance }) => {

  const [name, setName] = useState();
  const [wattage, setWattage] = useState();
  const [rate, setRate] = useState();
  const [hours, setHours] = useState();
  const [days, setDays] = useState();

  useEffect(() => {
    if (editAppliance !== undefined) {
      setName(editAppliance.name);
      setWattage(editAppliance.wattage);
      setRate(editAppliance.rate);
      setHours(editAppliance.hours);
      setDays(editAppliance.days);
    }
  }, [editAppliance]);

  const handleAddUpdateAppliance = () => {
    const dailykwh = (wattage * hours ) / 1000;
    const kwh = Math.round((dailykwh * days + Number.EPSILON) * 100) / 100;
    const cost = Math.round((kwh * rate + Number.EPSILON) * 100) / 100;

    if (editApplianceId !== undefined) {
      updateAppliance(editApplianceId, {
        name, wattage, rate, hours, days,
        kwh, cost
      });
      handleClearForm();
    } else {
      addAppliance({
        name, wattage, rate, hours, days,
        kwh, cost
      });
      handleClearForm();
    }
  };

  const handleClearForm = () => {
    setName('');
    setWattage('');
    setRate('');
    setHours('');
    setDays('');
    clear();
  };

  const updateInput = (which, input) => {
    switch(which) {
      case "name":
        setName(input);
        break;
      case "wattage":
        setWattage(input);
        break;
      case "rate":
        setRate(input);
        break;
      case "hours":
        setHours(input);
        break;
      case "days":
        setDays(input);
        break;
    }
  };

  return (
    <Form>
      <Form.Group controlId="formBasicAppliance">
        <Form.Label>Appliance</Form.Label>
        <Form.Control type="text" value={name} placeholder="Enter appliance name" onChange={e => updateInput("name", e.target.value)}/>
      </Form.Group>
      <Form.Group controlId="formBasicWattage">
        <Form.Label>Wattage (power in watts)</Form.Label>
        <Form.Control type="text" value={wattage} placeholder="Enter wattage"  onChange={e => updateInput("wattage", e.target.value)}/>
      </Form.Group>  
      <Form.Group controlId="formBasicRate">
        <Form.Label>Utility rate (per kWH)</Form.Label>
        <Form.Control type="text" value={rate} placeholder="Enter utility rate"  onChange={e => updateInput("rate", e.target.value)}/>
      </Form.Group>  
      <Form.Group controlId="formBasicHours">
        <Form.Label>Hours used per day</Form.Label>
        <Form.Control type="text" value={hours} placeholder="Enter no of hours used"  onChange={e => updateInput("hours", e.target.value)}/>
      </Form.Group>  
      <Form.Group controlId="formBasicDays">
        <Form.Label>Days used per year</Form.Label>
        <Form.Control type="text" value={days} placeholder="Enter no of days used"  onChange={e => updateInput("days", e.target.value)}/>
      </Form.Group>  

      <Button variant="primary" onClick={handleAddUpdateAppliance}>
        {editApplianceId !== undefined?"Save":"Add"}
      </Button>{' '}
      <Button variant="secondary" onClick={handleClearForm}>
        Clear
      </Button>
    </Form>
    );
  };

const mapStateToProps = state => {
    return {editAppliance: state[0].editAppliance, editApplianceId: state[0].editApplianceId};
};


export default connect(
  mapStateToProps,
  { addAppliance, clear, updateAppliance }
)(EnergyForm);